module.exports = __webpack_public_path__ + "img/Color S140.f03cffac.jpg";